import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mga-page__header" }
const _hoisted_2 = { class: "mga-page__actions" }
const _hoisted_3 = { class: "mga-page__actions_round-wrapper" }
const _hoisted_4 = { class: "mga-page__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportTimestamp = _resolveComponent("ReportTimestamp")!
  const _component_DownloadActions = _resolveComponent("DownloadActions")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MgaReportListFilter = _resolveComponent("MgaReportListFilter")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_MgaReportList = _resolveComponent("MgaReportList")!
  const _component_MgaTotalList = _resolveComponent("MgaTotalList")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_TwoFactorAuthDialog = _resolveComponent("TwoFactorAuthDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { class: "mga-page" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", null, "MGA Report by " + _toDisplayString(_ctx.reportPeriod), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isTimestampAllowed)
              ? (_openBlock(), _createBlock(_component_ReportTimestamp, { key: 0 }))
              : _createCommentVNode("v-if", true),
            (_ctx.isReportDownloadAllowed)
              ? (_openBlock(), _createBlock(_component_DownloadActions, {
                  key: 1,
                  class: "mga-page__actions_button",
                  type: "primary",
                  "is-loading": _ctx.isReportListLoading,
                  onGetReport: _ctx.openTwoFactorDialog
                }, null, 8 /* PROPS */, ["is-loading", "onGetReport"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_popover, {
                "popper-class": "mga-page-filter",
                placement: "bottom",
                "show-arrow": false,
                width: 400,
                visible: _ctx.isFilterVisible
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    loading: _ctx.isReportListLoading,
                    round: "",
                    icon: _ctx.icons.Filter,
                    onClick: _ctx.openFilter
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createTextVNode(" Filters ", -1 /* CACHED */)),
                      _createVNode(_component_el_tag, {
                        class: "mga-page__filter-counter",
                        effect: "dark",
                        round: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.activeFiltersCount), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["loading", "icon", "onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_MgaReportListFilter)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["visible"]),
              _createVNode(_component_el_button, {
                loading: _ctx.isReportListLoading,
                circle: "",
                icon: _ctx.icons.Refresh,
                onClick: _ctx.refreshFilter
              }, null, 8 /* PROPS */, ["loading", "icon", "onClick"])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.reportList?.countryData.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportList.countryData, (countryItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: countryItem.countryName
                      }, [
                        _createVNode(_component_MgaReportList, { report: countryItem }, null, 8 /* PROPS */, ["report"]),
                        _createVNode(_component_MgaTotalList, {
                          class: "mga-page__total",
                          "total-report": countryItem.total,
                          "total-text": "Total"
                        }, null, 8 /* PROPS */, ["total-report"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }),
                (_ctx.reportList?.total)
                  ? (_openBlock(), _createBlock(_component_MgaTotalList, {
                      key: 0,
                      "total-report": _ctx.reportList.total,
                      "total-text": "Total for all countries"
                    }, null, 8 /* PROPS */, ["total-report"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "No data"
              }))
        ])), [
          [_directive_loading, _ctx.isReportListLoading]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    (_ctx.isTwoFactorDialogVisible)
      ? (_openBlock(), _createBlock(_component_TwoFactorAuthDialog, {
          key: 0,
          action: _ctx.getReportListCsv
        }, null, 8 /* PROPS */, ["action"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}